import React from 'react';

/**
 *
 */
export default function UpdateButton({
  navigate,
  id,
  baseURL,
  disabled,
  hasUpdatePermission,
  showDetailWhileNoUpdatePermission = false,
}) {
  const url = [
    baseURL.replace(/^\/?/, '/').replace(/\/?$/, '/'),
    id,
  ].join('');
  const handleClick = () => {
    navigate(url);
  };
  return showDetailWhileNoUpdatePermission || hasUpdatePermission ? <button
    type="button"
    className="btn btn-sm btn-link"
    onClick={handleClick}
    disabled={disabled}
  >
    {hasUpdatePermission ? <>
      <svg className="btn__icon btn__icon--sm me-1" aria-hidden="true">
        <use href="#ico-edit"></use>
      </svg>
      修改
    </> : <>查看內容</>}
  </button> : null;
}
